<template>
    <div>
        <form class="home-form">
            <fieldset>
                <div class="error-msg" v-if="signUpError">{{ signUpError }}</div>
                <!-- Non-gift -->
                <template v-if="!isGift">
                    <!-- First & last name -->
                    <div class="input-group">
                        <div class="input-wrapper-md">
                            <label for="buy-now-first-name">*First</label>
                            <input id="buy-now-first-name" type="text" v-model="accountData.firstName" :class="validationStatus($v.accountData.firstName)">
                        </div>

                        <div class="input-wrapper-md">
                            <label for="buy-now-last-name">*Last</label>
                            <input id="buy-now-last-name" type="text" v-model="accountData.lastName" :class="validationStatus($v.accountData.lastName)">
                        </div>
                    </div>
                    <div class="error-msg" v-if="showValidationErrors && (!$v.accountData.firstName.required || !$v.accountData.lastName.required)">Name is required.</div>

                    <!-- Email -->
                    <template v-if="!isUserSignedIn">
                        <div class="input-group">
                            <div class="input-wrapper-lg">
                                <label for="buy-now-email">*Email</label>
                                <input id="buy-now-email" type="text" v-model.lazy="accountData.email" :class="validationStatus($v.accountData.email)" :readonly="isUserSignedIn">
                            </div>
                        </div>
                        <div class="error-msg" v-if="showValidationErrors && !$v.accountData.email.required">Email is required.</div>
                        <div class="error-msg" v-if="showValidationErrors && $v.accountData.email.required && !$v.accountData.email.email">Email is invalid.</div>
                        <div class="error-msg" v-if="emailError">{{ emailError }}</div>
                        
                        <!-- Password -->
                        <fieldset v-if="!isUserSignedIn && !isGift">
                            <p v-if="!onboarding" class="font-sm font-green password-note">Make checkout easier next time by creating a free account:</p>
                            <div class="input-group">
                                <div class="input-wrapper-lg">
                                    <label for="buy-now-password">*Password</label>
                                    <input id="buy-now-password" type="password" v-model="accountData.password" :class="validationStatus($v.accountData.password)" autocomplete="off">
                                </div>
                            </div>

                            <div class="error-msg" v-if="showValidationErrors && !$v.accountData.password.required">
                                Password is required and your password must be at least 6 characters long.
                            </div>
                            <div class="error-msg" v-if="!$v.accountData.password.minLength">
                                Your password must be at least 6 characters long.
                            </div>
                        </fieldset>
                        <hr>
                    </template>
                    
                </template>

                <!-- Gift friend name -->
                <template v-else >
                    <div class="input-group">
                        <div class="input-wrapper-lg">
                            <label for="buy-now-friend-name">Their Name</label>
                            <input id="buy-now-friend-name" type="text" v-model="giftData.friendName" :class="validationStatus($v.giftData.friendName)">
                        </div>
                    </div>
                    <div class="error-msg" v-if="showValidationErrors && !$v.giftData.friendName.required">Name is required.</div>
                </template>

                <!-- Shipping -->
                <shipping-form
                        v-if="addressRequired"
                        :is-gift="isGift"
                        :user-address="userData && userData.shipping"
                        :subscribe="subscribe"
                        :sign-up="singUp"
                        :onboarding="onboarding"
                        v-on:validated="onAddressValidated"
                        v-on:postal-code-changed="copyPostalCode"
                        v-on:validation-failed="processing = false"
                        ref="shippingForm"
                />

                <template v-if="isGift">
                    <!-- Friend email -->
                    <div class="input-wrapper-lg">
                        <label class="radio-label">Send them an email?</label>
                        <input type="radio" id="send-email-true" :value="true" v-model="giftData.sendEmail">
                        <label class="radio-option-label" for="send-email-true">yes please</label>
                        <input type="radio" id="send-email-false" :value="false" v-model="giftData.sendEmail">
                        <label class="radio-option-label-last" for="send-email-false">no thanks</label>
                    </div>

                    <template v-if="giftData.sendEmail">
                        <div class="input-wrapper-lg">
                            <div class="input-wrapper-lg">
                                <label for="friend-email">Their Email</label>
                                <input id="friend-email" type="text" v-model.lazy="giftData.friendEmail" :class="validationStatus($v.giftData.friendEmail)">
                            </div>
                        </div>
                        <div class="error-msg" v-if="showValidationErrors && !$v.giftData.friendEmail.required">Email is required.</div>
                        <div class="error-msg" v-if="showValidationErrors && !$v.giftData.friendEmail.email">Email is invalid.</div>
                    </template>

                    <!-- Message -->
                    <label for="gift-message">Custom message printed on package:<span class="gift-message-size">{{ giftData.message.length }}/140</span></label>
                    <div class="textarea-wrapper">
                        <textarea name="gift-message" id="gift-message" :rows="isUserSignedIn ? 4 : 2" v-model="giftData.message"></textarea>
                    </div>

                    <template v-if="!isUserSignedIn">
                        <hr>
                        <!-- Gifter details -->
                        <div class="input-group">
                            <div class="input-wrapper-lg">
                                <label for="buy-now-gifter-name">Your Name</label>
                                <input id="buy-now-gifter-name" type="text" v-model="giftData.gifterName" :class="validationStatus($v.giftData.gifterName)">
                            </div>
                            <div class="error-msg" v-if="showValidationErrors && !$v.giftData.gifterName.required">Your name is required.</div>

                            <div class="input-wrapper-lg">
                                <label for="buy-now-gifter-email">Your Email</label>
                                <input id="buy-now-gifter-email" type="text" v-model.lazy="giftData.gifterEmail" :class="validationStatus($v.giftData.gifterEmail)">
                            </div>
                            <div class="error-msg" v-if="showValidationErrors && !$v.giftData.gifterEmail.required">Email is required.</div>
                            <div class="error-msg" v-if="showValidationErrors && !$v.giftData.gifterEmail.email">Email is invalid.</div>
                            <div class="error-msg" v-if="emailError">This email is associated with an existing account.<br>Please login so your purchase will be retained in your history.</div>
                        </div>
                    </template>

                </template>
            </fieldset>

            <billing-form v-if="!hasBillingInfo && !hasEnoughCredit"
                    :stripe-publishable-key="stripePublishableKey"
                    :signup-only="singUp"
                    v-on:tokenRetrieved="onStripeTokenRetrieved"
                    v-on:userDataRetrieved="onStripeUserDataRetrieved"
                    ref="billingForm"
            />

            <div class="align-center">
                <button class="btn-green-lg checkout-btn" type="button" @click="validate()">
                    <div v-if="processing" class="spinner">
                        &nbsp
                    </div>
                    <span v-else>
                        {{ signUpOnly ? 'Create Free Account' : 'Continue' }}
                    </span>
                </button>
            </div>
        </form>

        <div v-if="!isUserSignedIn && !onboarding && !isGift" class="login-btn-wrapper">
            <span @click="$emit('login')">Login to Existing Account</span>
        </div>
    </div>
</template>

<script>
    import ShippingForm from '../../common/form-shipping.vue';
    import BillingForm from '../../common/form-billing.vue';
    import { validationMixin } from 'vuelidate';
    import { required, requiredIf, minLength, email } from 'vuelidate/lib/validators';
    import LocationMixin from  '../../../mixins/location-mixin';

    export default {
        components: {
            ShippingForm,
            BillingForm
        },
        mixins: [
            LocationMixin,
            validationMixin
        ],
        props: {
            stripePublishableKey: String,
            signUpError: String,
            isUserSignedIn: Boolean,
            hasBillingInfo: Boolean,
            userData: Object,
            onboarding: Boolean,
            signUpOnly: Boolean,
            isGift: Boolean,
            hasEnoughCredit: Boolean,
            subscribe: Boolean

        },
        data: function() {
            return  {
                accountData: {
                    firstName: undefined,
                    lastName: undefined,
                    email: undefined,
                    password: undefined,
                },
                giftData: {
                    friendName: undefined,
                    sendEmail: false,
                    friendEmail: undefined,
                    message: '',
                    gifterName: undefined,
                    gifterEmail: undefined,
                },
                cardNumber: undefined,
                stripeTokenId: null,
                billingZip: undefined,
                emailError: undefined,
                passwordRequiredError: false,
                showValidationErrors: false,
                giftAddressError: false,
                processing: false,
                address: undefined,
                skipAddressValidation: false,
                singUp: this.signUpOnly
            }
        },
        validations: {
            accountData: {
                firstName: {
                    required: requiredIf(function() {
                        return !this.isGift;
                    })
                },
                lastName: {
                    required: requiredIf(function() {
                        return !this.isGift;
                    })
                },
                email: {
                    required: requiredIf(function() {
                        return !this.isGift;
                    }),
                    email
                },
                password: {
                    minLength: minLength(6),
                    required: requiredIf(function() {
                        return !this.isGift && this.onboarding;
                    }),
                }
            },
            giftData: {
                friendName: {
                    required: requiredIf(function() {
                        return this.isGift;
                    }),
                },
                friendEmail: {
                    required: requiredIf(function() {
                        return this.isGift && this.giftData.sendEmail;
                    }),
                    email
                },
                gifterName: {
                    required: requiredIf(function() {
                        return this.isGift && !this.isUserSignedIn;
                    })
                },
                gifterEmail: {
                    required: requiredIf(function() {
                        return this.isGift && !this.isUserSignedIn;
                    }),
                    email
                }
            },
        },

        methods: {
            saveFormValues() {
                localStorage.setItem('accountFormValues', JSON.stringify(this.accountData));
            },
            loadFormValues() {
                  const savedFormValues = localStorage.getItem('accountFormValues');
                  if (savedFormValues) {
                    const parsedFormValues = JSON.parse(savedFormValues);
                    this.accountData = parsedFormValues;
                  }
            },
            validate() {
                this.processing = true;
                if (!this.isFormValid()) {
                    this.processing = false;
                    return;
                }

                this.address = undefined;

                if(this.singUp && this.onboarding){

                    let cardValue = this.$refs.billingForm.cardNo();
                    let expDate = this.$refs.billingForm.expDate();
                    let cvcValue = this.$refs.billingForm.cvcNo();
                    if((cardValue === 'complete') || (cardValue === 'invalid') || (expDate === 'complete') ||  (expDate === 'invalid') || (cvcValue === 'complete')){
                        if(!this.hasBillingInfo && !this.stripeTokenId && !this.hasEnoughCredit) {
                            this.$refs.billingForm.getStripeTokenId();
                            return;
                        }
                    }

                    if (!this.isUserSignedIn) {   
                        this.verifyEmailAndAddress();
                    } else {
                        this.$refs.shippingForm.validateAddress();
                    }

                }else{

                    if(!this.hasBillingInfo && !this.stripeTokenId && !this.hasEnoughCredit) {
                        this.$refs.billingForm.getStripeTokenId();
                        return;
                    }

                    if (!this.isUserSignedIn) {
                        this.verifyEmailAndAddress();
                    } else {
                        this.$refs.shippingForm.validateAddress();
                    }
                }

            },
            isFormValid() {
                this.$v.$touch();
                this.showValidationErrors = true;
                return !this.$v.$anyError;
            },
            onStripeTokenRetrieved(tokenId) {
                this.stripeTokenId = tokenId;
                this.validate();
            },
            onStripeUserDataRetrieved(tokenId, userData) {
                this.stripeTokenId = tokenId;
                if (userData.email) this.accountData.email = userData.email;
                this.$refs.shippingForm.assignAddress({
                    street1: userData.street1,
                    street2: userData.street2,
                    city: userData.city,
                    state: userData.state,
                    postalCode: userData.postalCode
                });
            },
            validationStatus(validation) {
                if (validation.$error) {
                    return 'input-error'
                }
            },
            onAddressValidated(address) {
                this.address = address;
                this.submit();
            },
            verifyEmailAndAddress() {
                this.emailError = undefined;

                this.$api.post('v1/accounts/verify_email', { email: this.accountData.email || this.giftData.gifterEmail })
                    .then(res => this.$refs.shippingForm.validateAddress())
                    .catch(err => {
                        this.emailError = err.response.data.message;
                        this.processing = false;
                    });
            },
            submit() {
                this.$emit('submit', this.accountData, this.address, this.stripeTokenId, this.giftData);
                this.processing = false;
            },
            restrictCharacters(evt) {
                // Allow numbers and '-' input only
                evt = (evt) ? evt : window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 45 && charCode !== 46 ) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            copyPostalCode(postalCode) {
                if (this.$refs.billingForm && postalCode !== '') {
                    this.$refs.billingForm.setZip(postalCode);
                }
            }
        },
        computed: {
            addressRequired: function() {
                return true;
            }
        },
        watch: {
            'accountData.firstName': 'saveFormValues',
            'accountData.lastName': 'saveFormValues',
            'accountData.password': function () {
                // TODO: this watch doesn't work somehow????
                if (this.accountData.password && this.accountData.password > 0) {
                    this.passwordRequiredError = false;
                }
            },
            'giftData.message': function () {
                if (this.giftData.message.length > 140) {
                    this.giftData.message = this.giftData.message.slice(0, 140);
                }
            }
        },
        mounted() {
            this.loadFormValues();
            if (this.userData) {
                if (this.userData.username) {
                    // HACK:
                    const nameArr = this.userData.username.split(' ');
                    if (nameArr.length > 1) {
                        this.accountData.firstName = nameArr[0];
                        this.accountData.lastName = nameArr[1];
                    }
                }

                this.accountData.email = this.userData.email;

                if (this.userData.shipping && !this.isGift) {
                    this.$refs.shippingForm.assignAddress(this.userData.shipping);

                    if (this.$refs.billingForm) {
                        this.$refs.billingForm.setZip(this.userData.shipping.postalCode);
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/_variables_home.scss";
    @import "../../../styles/common_home.scss";
    @import "../../../styles/form_home.scss";

    .password-note {
        margin: 4px 1rem;
        text-align: left;
    }
    .checkout-btn {
        margin-top: 1.5rem;
        margin-bottom: 1rem;
        width: 75%;
    }
    .gift-message-size {
        float: right;
        font-size: 12px;
        width: 40px;
    }
    .login-btn-wrapper {
        text-align: center;
        margin-bottom: 1rem;
        cursor: pointer;
        &:hover {
            color: lighten($color-primary, 10%);
        }
    }
    .gift-note {
        color: $green-primary;
        font-size: 14px;
        text-align: center;
        margin: 0 0 1rem 0
    }

    @media only screen and (max-width: $max-mobile-sm-width) {
        .gift-message-size {
            width: 65px;
        }
        .input-wrapper-lg .radio-option-label {
            width: 55px;
        }
    }
</style>